import { Link } from "react-router-dom";
import { ArrowUpRight, Gauge } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";

export const RiskTeaser = () => (
  <section id="risk-score" className="relative py-20 sm:py-24 btr-bg-graphite overflow-hidden" data-testid="risk-teaser-section">
    <div className="absolute inset-0 btr-grid opacity-20 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-6 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
      <SectionHead
        badge="Risk Readiness Score"
        title={<>How prepared are you <span className="text-[#a2020b]">before</span> the risk?</>}
        lede="Six quick questions. An instant, preliminary readiness score — no email required."
      />
      <Link to="/risk-score" className="btr-reveal btr-btn-primary btr-cta-breathe self-start lg:self-auto flex-shrink-0" data-testid="risk-teaser-cta">
        <Gauge className="w-4 h-4" /> Take the Risk Score <ArrowUpRight className="w-4 h-4" />
      </Link>
    </div>
  </section>
);
